import { Component } from '@verndale/core';

class Module extends Component {
  async setupDefaults() {
    // eslint-disable-next-line no-undef
    await new Promise(resolve => {
      requestAnimationFrame(() => resolve());
    });

    this.dom = {
      $form: this.el._$('.careers-search-bar__form'),
      $locationSelect: this.el._$('.careers-search-bar__location-select select'),
      $locationList: this.el._$('.careers-search-bar__location-select .dropdown__list'),
      $countrySelect: this.el._$('.careers-search-bar__country-select select'),
      $countryOptions: this.el._$$('.careers-search-bar__country-select select option'),
      $locationSelectOptions: this.el._$$('.careers-search-bar__location-select select option'),
      $locationListOptions: this.el._$$('.careers-search-bar__location-select .dropdown__item'),
      $dropdownTrigger: this.el._$('.careers-search-bar__location-select .dropdown__trigger')
    };

    this.allLocationSelectOptions = this.dom.$locationSelectOptions;
    this.allLocationListOptions = this.dom.$locationListOptions;
    this.searchUrlUS = this.el.dataset.searchUrlUs;
    this.searchUrlCA = this.el.dataset.searchUrlCa;
    this.filterTagUS = this.el.dataset.filterTagUs.toLowerCase();
    this.filterTagCA = this.el.dataset.filterTagCa.toLowerCase();

    this.dom.$countryOptions.forEach(option => {
      if (option.dataset.filterTag.toLowerCase() === this.filterTagUS) {
        option.setAttribute('aria-selected', 'true')
      } else option.setAttribute('aria-selected', 'false')
    })


    const selectedCountryFilterTag = this.dom.$countryOptions.find(
      option => option.getAttribute('aria-selected') === 'true'
    ).dataset.filterTag;

    if (selectedCountryFilterTag){
      this.filterLocations(selectedCountryFilterTag)
    }

    this.setActionURL();
    this.delayedAddListeners();
  }

  setActionURL(){
    const selectedCountryFilterTag = [...this.dom.$countrySelect].find(
      option => option.getAttribute('aria-selected') === 'true'
    ).dataset.filterTag.toLowerCase();

    if (selectedCountryFilterTag === this.filterTagUS) {
      this.dom.$form.setAttribute('action', this.searchUrlUS)
    } else if (selectedCountryFilterTag === this.filterTagCA){
      this.dom.$form.setAttribute('action', this.searchUrlCA)
    }
  }

  delayedAddListeners(){
    this.dom.$countrySelect.addEventListener('option', this.handleCountryChange.bind(this))
  }

  filterLocations(filterTag){
    this.dom.$locationListOptions.forEach(el => {
      el.remove()
    });
    this.dom.$locationSelectOptions.forEach(el => {
      el.remove()
    });

    this.allLocationListOptions.forEach((el, i) => {
      if (i===0) {
        el.setAttribute('aria-selected', true)
        this.dom.$locationList.appendChild(el)
      } else if (el.dataset.filterTag === filterTag) {
        this.dom.$locationList.appendChild(el)
      } else {
        el.setAttribute('aria-selected', false)
      }
    })

    this.allLocationSelectOptions.forEach((el, i) => {
      if (i===0) {
        el.setAttribute('aria-selected', true)
        this.dom.$locationSelect.appendChild(el)
      } else if (el.dataset.filterTag === filterTag) {
        this.dom.$locationSelect.appendChild(el)
      } else {
        el.setAttribute('aria-selected', false)
      }
    })

    if (this.allLocationListOptions[0]) {
      this.dom.$dropdownTrigger.innerHTML = this.allLocationListOptions[0].innerHTML;
    }
    this.dom.$locationSelect.selectedIndex = 0;
  }

  handleCountryChange(e){
    const selectedCountryFilterTag = [...e.currentTarget].find(
      option => option.getAttribute('aria-selected') === 'true'
    ).dataset.filterTag;

    if (selectedCountryFilterTag){
      this.filterLocations(selectedCountryFilterTag)
    }
    this.setActionURL();
  }
}

export default Module;
